import * as ActionTypes from '../ActionTypes';

const initialState = {
    atdPermissionLoading: false,
    attendancePermissionData: [],
    error: null,

};
export const AttendancePermissionReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.GET_ATTENDANCE_PERMISSION_REQUEST:
            return {
            ...state,
            atdPermissionLoading: true,
            error: null,
        };
        case ActionTypes.UPDATE_ATTENDANCE_PERMISSION_REQUEST:
        return {
            ...state,
            atdPermissionLoading: true,
            error: null,
        };

        case ActionTypes.GET_ATTENDANCE_PERMISSION_SUCCESS:
        case ActionTypes.UPDATE_ATTENDANCE_PERMISSION_SUCCESS:
        return {
            ...state,
            atdPermissionLoading: false,
            attendancePermissionData: action.payload?.data?.data || [],
            error: null,
        };

        case ActionTypes.GET_ATTENDANCE_PERMISSION_ERROR:
        case ActionTypes.UPDATE_ATTENDANCE_PERMISSION_ERROR:
        return {
            ...state,
            atdPermissionLoading: false,
            error: true,
        };
        default:
            return state;
    }
};
